function LegendItem({color, label}: {color: string; label: string}) {
  return (
    <li style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
      <span
        aria-hidden="true"
        style={{
          display: 'inline-block',
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: color,
        }}
      />

      <span style={{color: '#414449'}}>{label}</span>
    </li>
  );
}

export default LegendItem;
